export default {
  common: {
    search: '搜索',
    reset: '重置',
    add: '新增',
    edit: '编辑',
    delete: '删除',
    confirm: '确定',
    cancel: '取消',
    export: '导出',
    exportExcel: '导出 Excel',
    exportJson: '导出 JSON',
    import: '导入',
    refresh: '刷新',
    detail: '详情',
    status: '状态',
    action: '操作',
    save: '保存',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭全部',
    logout: '退出登录',
    logoutConfirm: '确认退出当前账号？',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏',
    collapse: '收起',
    expand: '展开',
    submit: '提交',
    back: '返回',
    keyword: '关键字',
    total: '共 {total} 条',
    createTime: '创建时间',
    startTime: '开始时间',
    endTime: '结束时间',
    enable: '启用',
    disable: '禁用',
    batchDelete: '批量删除',
    batchDisable: '批量禁用',
    columns: '列设置',
    density: '密度',
    exportPage: '导出当前页',
    exportAll: '导出全部',
    success: '操作成功',
    failed: '操作失败',
    all: '全部',
    empty: '暂无数据',
    tips: '提示',
    warning: '警告',
    retry: '重试',
    view: '查看',
    id: 'ID',
    reason: '原因',
    result: '结果',
    select: '请选择',
    input: '请输入',
    yes: '是',
    no: '否',
    copy: '复制',
    remark: '备注',
    time: '时间',
    ip: 'IP',
    device: '设备',
    operator: '操作人',
    name: '名称',
    description: '简介',
    type: '类型',
    count: '数量',
    next: '下一步',
    prev: '上一步',
    download: '下载',
    upload: '上传',
    preview: '预览',
    template: '模板',
    processing: '处理中…',
    uploadTip: '支持 {accept} 格式，单次一个文件',
    removeFirst: '请先移除已选文件',
    parseFailed: '解析失败：{message}',
  },
  route: {
    login: '登录',
    dashboard: '看板',
    user: '用户管理',
    userList: '用户列表',
    userDetail: '用户详情',
    wordbook: '官方词库',
    wordbookList: '词库列表',
    wordbookImport: '词库导入',
    word: '词条维护',
    wordList: '词条列表',
    wordImport: '词条导入',
    dictionary: '词典管理',
    dictionaryList: '词典列表',
    dictionaryDetail: '词典详情',
    review: '复习任务',
    reviewTask: '复习任务队列',
    system: '系统管理',
    systemConfig: '系统配置',
    systemLog: '审计日志',
    systemProfile: '个人中心',
    forbidden: '无权限',
    notFound: '页面不存在',
    unknown: '未命名',
  },
  login: {
    title: '记单词管理后台',
    subtitle: '欢迎回来，请登录你的管理员账号',
    username: '用户名',
    usernamePlaceholder: '请输入用户名',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    captcha: '验证码',
    captchaPlaceholder: '请输入 4 位验证码',
    remember: '记住登录（7 天）',
    forgot: '忘记密码？',
    submit: '登 录',
    submitting: '登录中…',
    success: '登录成功',
    contactAdmin: '忘记密码请联系超级管理员重置',
    strength: '密码强度',
    captchaRefresh: '点击刷新验证码',
    captchaFailed: '加载失败，点击重试',
    defaultPasswordTip: '当前使用的是默认密码，请尽快修改密码',
  },
  dashboard: {
    range: '时间范围',
    days7: '近 7 天',
    days30: '近 30 天',
    days90: '近 90 天',
    exportPng: '导出 PNG',
    totalUsers: '累计用户',
    todayNewUsers: '今日新增',
    totalWordbooks: '累计词库',
    totalDictionaries: '累计词典',
    todayActiveUsers: '今日活跃',
    todayLearnedWords: '今日学习词数',
    mom: '环比',
    userTrend: '新增用户与学习词数',
    accuracyTrend: '平均正确率趋势',
    languageDist: '词库语言分布',
    visibilityDist: '私有/公开词典占比',
    hotWords: '热词 TOP10',
    wordCloud: '热词词云',
    recentLogs: '最近管理员操作日志',
    abnormalLogins: '最近异常登录',
    newUsers: '新增用户',
    learnedWords: '学习词数',
    accuracy: '平均正确率',
    action: '动作',
    target: '目标',
    refreshTip: '数据每 60 秒自动刷新',
  },
  user: {
    username: '用户名',
    nickname: '昵称',
    phone: '手机号',
    email: '邮箱',
    role: '角色',
    status: '状态',
    registerTime: '注册时间',
    lastLogin: '最近登录',
    searchPlaceholder: '用户名 / 昵称 / 手机号',
    detail: '用户详情',
    stat: '学习统计',
    loginLogs: '登录记录',
    learnDays: '学习天数',
    streakDays: '连续打卡',
    totalLearned: '累计学习',
    accuracyRate: '正确率',
    todayLearned: '今日学习',
    todayDuration: '今日时长',
    dictionaryCount: '词典数',
    wrongCount: '错题数',
    disableConfirm: '确认禁用该用户？',
    disableTip: '禁用后该用户已签发的 token 立即失效，会被强制下线。',
    enableConfirm: '确认启用该用户？',
    deleteConfirm: '确认删除该用户？',
    deleteTip: '删除后该用户的学习记录、词典与错题将一并清理，且不可恢复。',
    batchDisableConfirm: '确认批量禁用选中用户？',
    batchDisableTip: '共 {count} 个用户将被禁用并踢线。',
    batchDeleteConfirm: '确认批量删除选中用户？',
    batchDeleteTip: '共 {count} 个用户及其数据将被永久删除。',
    resetPwd: '重置密码',
    resetPwdTitle: '密码已重置',
    resetPwdTip: '新密码仅展示一次，请及时告知用户：',
    changeRole: '改角色',
    changeRoleTitle: '修改用户角色',
    selectRole: '选择角色',
    exportUsers: '导出用户',
  },
  wordbook: {
    name: '词库名称',
    description: '简介',
    cover: '封面',
    langFrom: '源语言',
    langTo: '目标语言',
    sortOrder: '排序',
    status: '上架状态',
    wordCount: '词数',
    learnCount: '学习次数',
    cardView: '卡片视图',
    tableView: '表格视图',
    create: '新建词库',
    edit: '编辑词库',
    relatedWords: '关联词条',
    relatedLoadFailed: '加载失败，请关闭后重试',
    addWords: '加入已有词条',
    removeWords: '批量移除',
    adjustSort: '调整序号',
    import: '批量导入',
    export: '导出词库',
    deleteConfirm: '确认删除该词库？',
    deleteTip: '删除后引用该词库的官方词典可能受影响。',
    offline: '下架',
    online: '上架',
    offlineConfirm: '确认下架该词库？',
    onlineConfirm: '确认上架该词库？',
    coverTip: '支持拖拽上传或填写图片 URL',
  },
  word: {
    headword: '词条',
    phonetic: '音标',
    audio: '发音 URL',
    partOfSpeech: '词性',
    definition: '释义',
    example: '例句',
    exampleTrans: '例句译文',
    difficulty: '难度',
    etymology: '词源助记',
    create: '新建词条',
    edit: '编辑词条',
    inlineEdit: '行内编辑',
    references: '被引用情况',
    referencedBy: '被 {count} 个词库引用',
    noReference: '暂无词库引用',
    deleteConfirm: '确认删除该词条？',
    deleteBlocked: '该词条仍被 {count} 个词库引用，删除会影响这些词库',
    importTip: '同一「词条 + 词性」已存在时自动跳过',
    importWordbook: '目标词库',
    importWordbookPlaceholder: '请选择要导入的词库',
    importWordbookRequired: '请先选择目标词库',
    export: '导出词条',
    detailTitle: '词条详情',
  },
  dictionary: {
    name: '词典名称',
    owner: '所有者',
    visibility: '可见性',
    sourceType: '来源',
    wordCount: '词数',
    subscriberCount: '订阅数',
    recommendSort: '首页推荐',
    recommend: '推荐到首页',
    recommendTitle: '设置推荐状态',
    offline: '下架',
    offlineTitle: '下架违规词典',
    offlineReason: '下架原因',
    offlineTip: '下架后该词典将变为私有，并通知所有者。',
    deleteConfirm: '确认删除该词典？',
    deleteTip: '影响范围：{wordCount} 个词条、{subscriberCount} 个订阅用户、{sessionCount} 条学习记录。',
    words: '词条列表',
    subscribers: '订阅用户',
    statTitle: '学习数据概览',
    learnTimes: '学习次数',
    avgAccuracy: '平均正确率',
    lastLearnAt: '最近学习',
    learnerCount: '学习人数',
    export: '导出词典',
  },
  review: {
    queue: '复习任务队列',
    user: '用户',
    word: '词条',
    stage: '阶段',
    nextReviewAt: '下次复习时间',
    lastReviewAt: '上次复习时间',
    wrongTimes: '错误次数',
    mastered: '已掌握',
    trigger: '手动触发扫描',
    triggerConfirm: '确认立即触发复习任务扫描？',
    triggerTip: '将扫描全部到期错题并生成复习任务，用于替代定时任务补跑。',
    triggerResult: '扫描 {scanned} 条，新增 {generated} 条任务',
    history: '复习历史',
    fromStage: '原阶段',
    toStage: '新阶段',
    result: '结果',
    reviewedAt: '复习时间',
    correct: '答对',
    wrong: '答错',
  },
  system: {
    configTitle: '系统配置',
    configKey: '配置键',
    configValue: '配置值',
    description: '说明',
    valueType: '值类型',
    updatedAt: '最近修改时间',
    edit: '编辑配置',
    create: '新增配置',
    editConfirm: '确认修改该配置？',
    editTip: '配置项会影响 App 端行为，修改后请确认影响范围。',
    refreshDict: '同步刷新字典',
    logTitle: '审计日志',
    action: '动作',
    targetType: '目标类型',
    targetId: '目标 ID',
    detailTitle: '日志详情',
    beforeSnapshot: '变更前',
    afterSnapshot: '变更后',
    profileTitle: '个人中心',
    nickname: '昵称',
    phone: '手机号',
    email: '邮箱',
    avatar: '头像',
    changePassword: '修改密码',
    oldPassword: '原密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    passwordChanged: '密码修改成功，请重新登录',
  },
  error: {
    forbiddenTitle: '403',
    forbiddenDesc: '你没有访问该页面的权限，请联系超级管理员',
    notFoundTitle: '404',
    notFoundDesc: '访问的页面不存在或已被移除',
    backHome: '返回首页',
    backLogin: '返回登录',
  },
}
